import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Building2, FileCheck, Clock, ClipboardList, UserCheck, FileText } from 'lucide-react';

const services = [
  {
    icon: Building2,
    title: 'AZAV-Gründungsbegleitung',
    description: 'Komplette Unterstützung bis zur Trägerzulassung.'
  },
  {
    icon: FileCheck,
    title: 'Träger- und Maßnahmezulassung',
    description: 'Unterstützung bei neuen Maßnahmen und Erweiterungen.'
  },
  {
    icon: Clock,
    title: 'Auditvorbereitung',
    description: 'Kurzfristige Hilfe vor Überprüfungs- oder Maßnahmeaudits.'
  },
  {
    icon: ClipboardList,
    title: 'Internes Audit',
    description: 'Durchführung des vorgeschriebenen jährlichen internen Audits.'
  },
  {
    icon: UserCheck,
    title: 'Externer QM-Beauftragter',
    description: 'Laufende Betreuung des Qualitätsmanagements.'
  },
  {
    icon: FileText,
    title: 'Musterunterlagen & QM-System',
    description: 'Fertige Vorlagen und digitale Handbuchlösung für neue Träger.'
  }
];

export const Services = ({ showAll = false }) => {
  const displayedServices = showAll ? services : services;

  return (
    <section data-testid="services-section" className="py-24 md:py-32 bg-[#FAFAFA] relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <span className="text-sm uppercase tracking-widest text-primary font-semibold mb-4 block" data-testid="services-caption">
            Unsere Leistungen
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold tracking-tight mb-6 text-[#050505]" data-testid="services-headline">
            Leistungen für Bildungsträger
          </h2>
          <p className="text-base md:text-lg text-[#555555] leading-relaxed" data-testid="services-description">
            Von der Gründung über das Audit bis zur laufenden QM-Betreuung.
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="services-grid">
          {displayedServices.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative bg-white border border-[#E5E5E5] rounded-2xl p-8 hover:border-primary/50 hover:shadow-lg transition-all duration-300"
              data-testid={`service-card-${index}`}
            >
              {/* Icon */}
              <div className="w-14 h-14 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                <service.icon className="w-7 h-7 text-primary" />
              </div>

              {/* Content */}
              <h3 className="text-xl font-heading font-semibold text-[#050505] mb-3">{service.title}</h3>
              <p className="text-[#666666] text-sm leading-relaxed">{service.description}</p>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mt-12"
        >
          <Link to="/kontakt">
            <Button 
              data-testid="services-cta"
              variant="outline"
              className="bg-transparent border border-[#050505] hover:bg-[#050505] hover:text-white text-[#050505] rounded-lg px-8 py-6 text-lg transition-all"
            >
              Alle Leistungen besprechen
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
